import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import {
  ContainedButtonWithForwardArrow,
  StyledButton,
} from "react-common-ui-library/FPACT/Buttons";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import {
  BUTTON,
  CANCEL,
  NEXT_STEP,
  SPACING_3_4,
  SUBMIT,
  TEXT,
} from "../../Constants/CommonConstants";
import {
  AccountStyledButtonWrapper,
  StyledActionButtonsBox,
} from "../../Styles/Common/CommonStyles";

/**
 * @description Common component for the next and cancel buttons.
 * @param {function} cancelClickHandler Click Handler method for the cancel button.
 * @param {function} handleNextStep method to handle form submission.
 * @returns {ReactNode} Returns the next button and cancel buttons which can be rendered on the UI by calling component and .
 */

const AccountActionButtons = ({ cancelClickHandler, handleNextStep }) => {
  const intl = useIntl();
  const methods = useFormContext();

  return (
    <AccountStyledButtonWrapper>
      <StyledActionButtonsBox>
        <Stack spacing={SPACING_3_4}>
          {handleNextStep ? (
            <ContainedButtonWithForwardArrow
              id={NEXT_STEP}
              type={BUTTON}
              onClick={methods?.handleSubmit(handleNextStep)}
            >
              {intl.formatMessage({ id: NEXT_STEP })}
            </ContainedButtonWithForwardArrow>
          ) : (
            <ContainedButtonWithForwardArrow id={NEXT_STEP} type={SUBMIT}>
              {intl.formatMessage({ id: NEXT_STEP })}
            </ContainedButtonWithForwardArrow>
          )}
          <StyledButton
            variant={TEXT}
            fullWidth
            id={CANCEL}
            onClick={() => cancelClickHandler()}
          >
            {intl.formatMessage({
              id: CANCEL,
            })}
          </StyledButton>
        </Stack>
      </StyledActionButtonsBox>
    </AccountStyledButtonWrapper>
  );
};

AccountActionButtons.propTypes = {
  cancelClickHandler: PropTypes.func.isRequired,
  handleNextStep: PropTypes.func,
};

AccountActionButtons.defaultProps = {
  handleNextStep: null,
};

export default AccountActionButtons;
